export * from './logit-one-chooses-linescape-as-sailling-schedule-provider';


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/logit-one-chooses-linescape-as-sailling-schedule-provider/index.ts